import React, { useEffect, useState } from "react";
import { motion, useAnimation } from "framer-motion";
import "../css/AppointmentStatCard.css";

function AppointmentStatCard({ title, amount, count, percent, color, index = 0 }) {
  const percentageValue = parseFloat(percent);
  const [displayedPercent, setDisplayedPercent] = useState(0);
  const controls = useAnimation();

  useEffect(() => {
    // Start the full gray fill animation first
    const timer = setTimeout(() => {
      controls.start({ strokeDasharray: `${percentageValue}, 100` });
      // Count up number from 0 to target
      let current = 0;
      const increment = percentageValue / 30; // ~30 frames
      const countInterval = setInterval(() => {
        current += increment;
        if (current >= percentageValue) {
          setDisplayedPercent(percentageValue);
          clearInterval(countInterval);
        } else {
          setDisplayedPercent(Math.round(current));
        }
      }, 20); // 20ms interval (~600ms total)
    }, 600); // Delay start after gray preload

    return () => clearTimeout(timer);
  }, [percentageValue, controls]);

  return (
    <motion.div
      className="appointment-stat-card"
      initial={{ opacity: 0, y: 30, scale: 0.95 }}
      animate={{ opacity: 1, y: 0, scale: 1 }}
      transition={{ delay: index * 0.1, duration: 0.6, ease: "easeOut" }}
      style={{
        borderTop: `0.1px solid ${color}`,
        borderRight: `0.1px solid ${color}`,
        borderBottom: `0.1px solid ${color}`,
        borderLeft: `8px solid ${color}`,
      }}
    >
      <div className="stat-content">
        <div className="stat-title">{title}</div>

        <div className="stat-amount-row">
          <div className="stat-amount">{amount}</div>
          <div className="stat-counts">{count}</div>

          <div className="stat-percent-circle">
            <svg width="32" height="32" viewBox="0 0 36 36">
              {/* Full gray background circle */}
              <motion.path
                d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831
                   a 15.9155 15.9155 0 0 1 0 -31.831"
                fill="none"
                stroke="#eee"
                strokeWidth="3.8"
                initial={{ strokeDasharray: "0, 100" }}
                animate={{ strokeDasharray: "100, 100" }}
                transition={{ duration: 0.5, ease: "easeOut" }}
              />
              {/* Animated colored progress */}
              <motion.path
                d="M18 2.0845
                   a 15.9155 15.9155 0 0 1 0 31.831"
                fill="none"
                stroke={color}
                strokeWidth="3.8"
                strokeDasharray={`0, 100`}
                animate={controls}
                transition={{ duration: 1.2, ease: "easeInOut" }}
              />
              <text
                x="18"
                y="20.35"
                textAnchor="middle"
                fontSize="10"
                fill={color}
                className="stat-percentage-text"
              >
                {Math.round(displayedPercent)}%
              </text>
            </svg>
          </div>
        </div>

        <div className="stat-bar">
          <motion.div
            className="stat-fill"
            initial={{ width: 0 }}
            animate={{ width: percent }}
            transition={{ duration: 1.2, delay: 0.6, ease: "easeInOut" }}
            style={{ backgroundColor: color }}
          ></motion.div>
        </div>
      </div>
    </motion.div>
  );
}

export default AppointmentStatCard;
